import React, { useMemo } from 'react'
import classnames from 'classnames/bind'
// @ts-ignore no types
import config from '@adc/configment'
import { PhotoGallery } from '@adc/ui-adc'
import type { FeatureFlags } from '@adc/ui-adc'
import { useListingContext } from '../../context/listing'
// @ts-ignore no types
import styles from './index.scss'
const cx = classnames.bind(styles)

interface PropertyGalleryProps {
  featureFlags: FeatureFlags
}

const PropertyGallery = ({ featureFlags }: PropertyGalleryProps) => {
  const { listing } = useListingContext()

  // Memoize config to prevent unnecessary re-renders
  const galleryConfig = useMemo(
    () => ({
      GOOGLE_MAPS_API_KEY: config.get('GOOGLE_MAPS_API_KEY'),
      GOOGLE_MAPS_CHANNEL_NAME: config.get('GOOGLE_MAPS_CHANNEL_NAME'),
      GOOGLE_MAPS_MAP_ID: config.get('GOOGLE_MAPS_MAP_ID', 'DEMO_MAP_ID'),
      LISTING_DEFAULT_PHOTO_URL: config.get('LISTING_DEFAULT_PHOTO_URL', ''),
    }),
    []
  )

  return (
    <PhotoGallery
      className={cx('photo-gallery')}
      config={galleryConfig}
      listing={listing}
      featureFlags={featureFlags as Record<string, boolean>}
      displayBanner
      shouldShowRibbon={false}
      fluid={false}
      showMultiple={false}
    />
  )
}

export default React.memo(PropertyGallery)
